import { CompanyInfo } from "src/generated/graphqlTypes";
import { CompanyInfoFieldFragment } from "./companyInfoUtils.generated";

export const DEFAULTS: CompanyInfo = {
  name: "Homebound Technologies, Inc.",
  licenseNumber: "CACL #1043883",
  email: "TalkToAp@homebound.com",
  phoneNumber: "(424) 235-3966 x830",
  accountNumber: "932551119",
  federalId: "82-4219797",
};

/** Returns the appropriate company field value, Falls back to default values if the field is not available. */
export function getCompanyInfoField(project: CompanyInfoFieldFragment | undefined, field: keyof CompanyInfo): string {
  return project?.companyInfo?.[field] ?? DEFAULTS[field]!;
}
